module.exports = __webpack_public_path__ + "assets/media/sound2.06220741.mp3";